<template>
  <div class="el-checkbox">
    <CustomInput
        :label="L.checkboxLabel || 'Checkbox text'"
        :value="element.labels[lang]"
        @input="updateLabel($event)" />
    <CustomSwitch class="el-req" :value="element.required" :label="L.required || 'Required'" @input="set('required', $event)" />
  </div>
</template>

<script>
import CustomInput from '../../../../parts/CustomInput.vue'
import CustomSwitch from '../../../../parts/CustomSwitch.vue'

/**
 * 'checkbox' element: a single acknowledge checkbox with per-language text.
 */
export default {
  name: 'ElCheckbox',
  components: { CustomInput, CustomSwitch },
  props: {
    options: { type: Object, required: true },
    element: { type: Object, required: true },
    lang: { type: String, default: 'de' }
  },
  computed: {
    L() { return this.options.Lang || {}; }
  },
  methods: {
    set(key, val) { this.element[key] = val; },
    updateLabel(val) { this.$set(this.element.labels, this.lang, val); }
  }
};
</script>

<style scoped>
.el-checkbox { display: flex; align-items: flex-end; gap: 1.25rem; flex-wrap: wrap; }
.el-checkbox > :first-child { flex: 1; min-width: 200px; }
.el-req { margin-bottom: 0.5rem; }
</style>
